import gql from 'graphql-tag';

export default fields => gql`
mutation ($budgetLine: CreateBudgetLineInput!, $externalMaps: [CreateExternalMapsInput]!) {
    createBudgetLine (budgetLine: $budgetLine, externalMaps: $externalMaps) {
        __typename
        ${[...['id'].concat(fields)]}
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/BudgetLines/NewMutation.js